<template>
  <div id="newsletter-bottom" class="flex flex-col pb-8 xs:pb-16 px-4">
    <div v-if="!subscribed" class="mx-auto container">
      <div class="flex flex-col items-center justify-center w-full">
        <div class="w-full flex flex-wrap">
          <div class="relative w-full xs:w-1/2 pr-0 xs:pr-4">
            <div class="flex absolute inset-y-0 left-0 items-center pl-4 mb-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill h-8 xs:h-10 w-6 xs:w-8 text-rspurple" viewBox="0 0 16 16">
                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
              </svg>
            </div>
            <input class="w-full fs-input h-12 xs:h-16 rounded-2xl pl-12 xs:pl-16 mt-2 text-base xs:text-xl" name="Name" type="text" placeholder="Name" v-model.trim="name">
          </div>
          <div class="relative w-full xs:w-1/2 pl-0 xs:pl-4">
            <div class="flex absolute inset-y-0 left-0 items-center pl-4 xs:pl-8 mb-3">
              <svg aria-hidden="true" class="w-6 xs:w-8 h-8 xs:h-10 text-rspurple" fill="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/></svg>
            </div>
            <input class="w-full fs-input h-12 xs:h-16 rounded-2xl pl-12 xs:pl-16 mt-2 text-base xs:text-xl" name="email" type="text" placeholder="Email" v-model.trim="email">
          </div>
        </div>
        <div class="w-full flex flex-wrap my-16 px-4 xs:px-6">
          <img class="w-6 xs:w-8 h-6 xs:h-8" :src="require('images/newsletter_page/what_describes_you.svg')" />
          <div class="flex flex-wrap w-auto md:w-1/5 lg:w-1/5 pl-3 xs:pl-5 ">
            <p class="text-sm xs:text-base sm:text-lg md:text-xl lg:text-2xl text-color-1">{{ question_1.text }}</p> 
          </div>
          <div class="flex flex-wrap pl-1 xs:pl-4 md:pl-0">
            <div v-for="(answer, ans_index) in answers_1" class="flex px-8 mt-4 sm:mt-0 md:mt-0" :key="ans_index">
              <label class="items-center flex justify-center" >
                <input class="h-6 w-6 rounded-full custom-radio custom-radio-wd-ht-xs xs:custom-radio-wd-ht" type="radio" :value="answer.value" name="answers_1" :id="ans_index" v-model="interest_type"><span class="text-sm xs:text-base sm:text-lg md:text-xl lg:text-2xl pl-2 xs:pl-4 text-color-1">{{answer.text}}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="w-full flex flex-col px-4 xs:px-6">
          <div class="flex">
            <img class="w-6 xs:w-8 h-6 xs:h-8" :src="require('images/newsletter_page/primary_interests.svg')" />
            <div class="flex flex-wrap pl-3 xs:pl-5 mb-3">
              <p class="text-sm xs:text-base sm:text-lg md:text-xl lg:text-2xl text-color-1">{{ question_2.text }}</p> 
            </div>
          </div>
          <div class="flex flex-col pl-1 xs:pl-0">
            <div v-for="(answer, ans_index) in answers_2" class="flex pl-8 xs:pl-12 mt-4" :key="ans_index">
              <label class="items-start flex" >
                <input class="mr-tp-0 sm:mr-tp-6 h-6 w-6 rounded-full text-rspurple custom-checkbox custom-checkbox-wd-ht-xs xs:custom-checkbox-wd-ht flex-shrink-0" type="checkbox" v-model="interests" :value="answer.value" name="answers_1" :id="ans_index"><span class="text-sm xs:text-base sm:text-lg md:text-xl lg:text-2xl pl-2 xs:pl-4 text-color-1 font-light">{{answer.text}}</span>
              </label>
            </div>
          </div>
        </div>

        <div class="flex justify-center my-16 rs-purple-btn w-48 text-lg" @click.prevent="handleSubmit()">Subscribe Now</div>

        <div class="flex justify-center my-8">
          <p class="text-base xs:text-lg sm:text-xl md:text-2xl lg:text-3xl text-center font-light text-descrition px-10">We deliver <span class="SofiaPro-Medium text-base xs:text-lg sm:text-xl md:text-2xl lg:text-3xl font-semibold" style="white-space: nowrap;">high-impact</span> and <span class="SofiaPro-Medium text-base xs:text-lg sm:text-xl md:text-2xl lg:text-3xl font-semibold" style="white-space: nowrap;">data-driven</span> content to your inbox at the start of every month.</p>
        </div>
      </div>
    </div>
    <div v-else class="container mx-auto">
      <div class="flex flex-row flex-wrap">
        <div class="w-full sm:w-2/5 pl-16 xs:pl-20 sm:pl-12 lg:pl-16 pr-16 xs:pr-20 sm:pr-0 mt-0 sm:-mt-8 md:-mt-10 lg:-mt-12">
          <img class="" :src="require('images/newsletter_page/subscribed.png')" />
        </div>
        <div class="flex flex-col w-full sm:w-3/5 px-0 sm:px-16 md:px-20 mt-8 sm:-mt-6 md:mt-0">
          <div class="flex">
            <p class="text-base xs:text-lg md:text-xl lg:text-2xl font-light text-descrition text-center sm:text-left">Great job! Take a moment to appreciate your own journey and the progress you've made.</p>
          </div>

          <div class="flex justify-center sm:justify-start mt-10 sm:mt-6 md:mt-10">
            <p class="text-base xs:text-lg md:text-xl lg:text-2xl font-light text-descrition">We’ll see you in your inbox shortly. ✨</p>
          </div>

          <div class="flex justify-center sm:justify-start mt-10 sm:mt-6 md:mt-10">
            <p class="text-base xs:text-lg md:text-xl lg:text-2xl font-light text-descrition">Explore more <a target="_blank" href="https://yourdailyreset.com/resources" class="text-color-2">resources</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "section2",
  data() {
    return {
      name: null,
      email: null,
      question_1: {
        text: 'You are a',
      },
      answers_1: [
        {
          text: 'HR professional',
          value: "HR professional"
        },
        {
          text: 'C-level executive',
          value: "C-level executive"
        }
      ],
      interest_type: null,
      question_2: {
        text: 'Please select your primary interests (Can choose more than one)'
      },
      answers_2: [
        {
          text: 'Personal growth',
          value: "Personal growth"
        },
        {
          text: 'Leadership redefined',
          value: "Leadership redefined"
        },
        {
          text: 'Insights on workplace well-being and culture for HR professionals and leaders',
          value: "Insights on workplace well-being and culture for HR professionals and leaders"
        },
        {
          text: 'Latest industry updates and trends',
          value: "Latest industry updates and trends "
        },
        {
          text: 'Exclusive access: Reports, webinars, support group sessions and premium content',
          value: "Exclusive access: Reports, webinars, support group sessions and premium content"
        }
      ],
      interests: [],
      subscribed: false,
      serverResponse: {
        val: "",
        msg: "",
      },
    };
  },
  methods: {
    handleSubmit() {
      const interests = [];

      if (this.name !== null && this.email !== null && this.interest_type !== null && this.interests.length >0){
        if (this.interests.length > 0) {
          this.interests.forEach((item) => {
            interests.push(item);
          });
        }
        
        const data = {
          name: this.name,
          email: this.email,
          interests: interests,
          interest_type: this.interest_type,
        };
        fetch("/newsletter_lead", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
          .then((response) => response.json())
          .then((data) => {
            this.serverResponse.val = data.code;
            this.serverResponse.msg = data.msg;
            if (data.code == "1") {
              this.subscribed = true;
              this.clearInputFields();
            }else {
              this.serverResponse.val = "0";
              this.$swal({
                title: '',
                text: 'Oops! You’re already subscribed.',
                type: 'error',
                timer: 3000,
                showConfirmButton: true,
              })
            }
          })
          .catch((error) => {
            this.serverResponse.val = "0";
            this.serverResponse.msg = error;
          });
        }else{
          this.$swal({
            title: '',
            text: 'Please enter all the details',
            type: 'error',
            timer: 3000,
            showConfirmButton: true,
          })
        }
      },
      clearInputFields() {
        this.name = null;
        this.email = null;
        this.interest_type = null;
        this.interests = [];
      },
  },
}
</script>

<style lang="scss" scoped>
  .label {
    background-color: #fff;
    display: inline-block;
    cursor: pointer;
  }

  .text-color-1 {
    color: #5b5a59;
  }

  .text-color-2 {
    color: #8B40E2;
  }

  .text-descrition {
    font-family: SofiaProRegular;
    font-style: light;
    color: #5b5a59 !important;
  }

  .custom-checkbox {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: transparent;
    border: 1px solid #af9ac1; /* grey color for the outer circle */
    border-radius: 50%;
    outline: none;
    position: relative;
    cursor: pointer;
  }

  .custom-checkbox:checked {
    background-color: transparent; /* Remove background color */
  }

  .custom-checkbox:checked::before {
    content: '';
    background-color: #8a2be2; /* Purple color for the inner circle */
    border-radius: 50%;
    position: absolute;
    top: 25%;
    left: 25%;
    width: 50%;
    height: 50%;
  }

  .custom-radio {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: transparent;
    border: 1px solid #af9ac1; /* grey color for the outer circle */
    border-radius: 50%;
    outline: none;
    position: relative;
    cursor: pointer;
  }

  .custom-radio:checked {
    background-color: transparent; /* Remove background color */
  }

  .custom-radio:checked::before {
    content: '';
    background-color: #8a2be2; /* Purple color for the inner circle */
    border-radius: 50%;
    position: absolute;
    top: 25%;
    left: 25%;
    width: 50%;
    height: 50%;
  }

  @responsive {
    .custom-checkbox-wd-ht-xs {
      width: 1.25em;
      height: 1.25em;
    }
    .custom-checkbox-wd-ht {
      width: 1.5em;
      height: 1.5em;
    }
    .custom-radio-wd-ht-xs {
      width: 1.25em;
      height: 1.25em;
    }
    .custom-radio-wd-ht {
      width: 1.5em;
      height: 1.5em;
    }
    .mr-tp-0 {
      margin-top: 0px;
    }
    .mr-tp-6 {
      margin-top: 6px;
    }
  }
</style>